import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import DashboardBreadcrumb from '../DashboardBreadcrumb';
import Passport360EnrollmentPolicyholderView from '../Passport360EnrollmentPolicyholderView';
import Passport360EnrollmentDOBView from '../Passport360EnrollmentDOBView';
import Passport360EnrollmentBeneficiariesOptionView from '../Passport360EnrollmentBeneficiariesOptionView';
import Passport360EnrollmentBeneficiariesView from '../Passport360EnrollmentBeneficiariesView';
import Passport360EnrollmentPlanTypeView from '../Passport360EnrollmentPlanTypeView';
import Passport360EnrollmentPlansView from '../Passport360EnrollmentPlansView';
import Passport360EnrollmentAddOnsView from '../Passport360EnrollmentAddOnsView';
import Passport360EnrollmentCheckoutView from '../Passport360EnrollmentCheckoutView';
import Passport360EnrollmentConfirmationView from '../Passport360EnrollmentConfirmationView';
import seo from '../../services/seo';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import './Passport360EnrollmentView.css';

const propTypes = {
  client: PropTypes.object,
  actor: PropTypes.oneOf(['broker', 'client']),
  isShareLinkFlow: PropTypes.bool,
};

const defaultProps = {
  isShareLinkFlow: false,
};

class Passport360EnrollmentView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      address: {},
      isLoading: true,
    };
  }

  componentDidMount() {
    const { match, getQuote, quote, getPlans, onNotifyError } = this.props;
    const { quoteId } = match.params;
    if (quoteId) {
      getQuote(quoteId)
        .then(() => {
          seo.setProps({
            title: 'Passport 360',
          });
          if (!isEmpty(get(quote, 'application.holders'))) {
            return getPlans(quoteId);
          } else {
            return Promise.resolve();
          }
        })
        .then(() => {
          this.setState({
            isLoading: false,
          });
        })
        .catch(onNotifyError);
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  get header() {
    const { client, quote, actor } = this.props;
    if (!quote) {
      return null;
    } else if (actor === 'broker') {
      return <DashboardBreadcrumb client={client} quote={quote} />;
    } else if (quote.broker && quote.brokerage) {
      return (
        <ol className="Passport360EnrollmentView-breadcrumb breadcrumb bg-master-light">
          <div className="container-fluid">
            <li className="breadcrumb-item bold">
              Prepared by {quote.broker.name} at {quote.brokerage.name}
            </li>
          </div>
        </ol>
      );
    } else {
      return null;
    }
  }

  render() {
    const { history, match, location } = this.props;
    const { isLoading } = this.state;

    return (
      <Fragment>
        {this.header}
        {isLoading ? (
          <div className="Passport360EnrollmentView-spinner">
            <i className="Passport360EnrollmentView-spinner-icon fas fa-circle-notch fa-spin" />
          </div>
        ) : (
          <div className="container-fluid">
            <Switch>
              <Route
                path={`${match.url}/policyholder`}
                render={() => (
                  <Passport360EnrollmentPolicyholderView
                    {...this.props}
                    onSubmit={() => {
                      history.push({
                        pathname: 'dob',
                        search: location.search,
                      });
                    }}
                  />
                )}
              />
              <Route
                path={`${match.url}/dob`}
                render={() => (
                  <Passport360EnrollmentDOBView
                    {...this.props}
                    onSubmit={() =>
                      history.push({
                        pathname: 'plan-type',
                        search: location.search,
                      })
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/plan-type`}
                render={() => (
                  <Passport360EnrollmentPlanTypeView
                    {...this.props}
                    onSubmit={() =>
                      history.push({
                        pathname: 'plans',
                        search: location.search,
                      })
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/plans`}
                render={() => (
                  <Passport360EnrollmentPlansView
                    {...this.props}
                    onSubmit={() =>
                      history.push({
                        pathname: 'add-ons',
                        search: location.search,
                      })
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/add-ons`}
                render={() => (
                  <Passport360EnrollmentAddOnsView
                    {...this.props}
                    onSubmit={() =>
                      history.push({
                        pathname: 'checkout',
                        search: location.search,
                      })
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/add-beneficiaries`}
                render={() => (
                  <Passport360EnrollmentBeneficiariesOptionView
                    {...this.props}
                    onSubmit={(hasBeneficiaries) =>
                      hasBeneficiaries
                        ? history.push({
                            pathname: 'beneficiaries',
                            search: location.search,
                          })
                        : history.push({
                            pathname: 'checkout',
                            search: location.search,
                          })
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/beneficiaries`}
                render={() => (
                  <Passport360EnrollmentBeneficiariesView
                    {...this.props}
                    onSubmit={() =>
                      history.push({
                        pathname: 'checkout',
                        search: location.search,
                      })
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/checkout`}
                render={() => (
                  <Passport360EnrollmentCheckoutView
                    {...this.props}
                    onSubmit={() =>
                      history.push(
                        `/dashboard/clients/${match.params.clientId}`
                      )
                    }
                  />
                )}
              />
              <Route
                path={`${match.url}/confirmation`}
                render={() => (
                  <Passport360EnrollmentConfirmationView {...this.props} />
                )}
              />
              <Redirect to={`${match.url}/policyholder`} />
            </Switch>
          </div>
        )}
      </Fragment>
    );
  }
}

Passport360EnrollmentView.propTypes = propTypes;
Passport360EnrollmentView.defaultProps = defaultProps;

export default withRouter(Passport360EnrollmentView);
